import CustomersView from './CustomersView';

export default CustomersView;
